module.exports = __webpack_public_path__ + "static/media/howdy-neighbour.ee3bc4fb.png";